import { RELATORIO_VEICULAR_ACCESS } from '../constants/modules';
import { isUsuarioUsoMuto } from '../utils';
import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';

/**
 * Quem pode acessar /v2/relatorio-veiculo (menu + tela).
 * Requer module configuration RELATORIO_VEICULAR_ACCESS vinculada ao userId logado.
 */
export function canViewVeiculoReport({ authData, userRole, moduleConfigurations }) {
  if (!authData?.id) return false;

  const role = userRole ?? authData.role;
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(role)) {
    return false;
  }

  return !!moduleConfigurations?.some(
    (m) => m.codigo === RELATORIO_VEICULAR_ACCESS && m.userId === authData.id,
  );
}
